"use client"

import Logo from "../shared/logo";
import navigation from "@/data/footerNavigation.json"

export default function Footer() {

  return (
    <>
      <footer className="footer bg-neutral-300">
        <div className="container">
          <div className="footer__wrapper">
            <div className="row">

              <div className="col-lg-3  col-md-4 col-sm-6">
                <div className="footer__logo-wrapper">
                  <Logo />
                  <p className="footer__decs">
                    USEPDF is a sophisticated and powerful web-based application designed to provide a wide range of
                    functions to manage your PDF files. Whether you need to merge multiple PDF files, accurately add or remove
                    pages, compress files or extract text using the latest OCR technology, UsePDF is the ultimate solution.
                  </p>
                </div>
              </div>

              {navigation.map((item: any, index: number) =>
                <div className="col-xl-2 col-lg-3  col-md-4 col-sm-6 " key={"item_" + item.name}>
                  <div className="footer__tools-wrapper">
                    <h4 className="footer__heading mt-200 text-decoration-none">
                      {item.name}
                    </h4>
                    <ul className="d-flex flex-column gap-100 p-0">
                      {item.subitems.map((subitem: any) =>

                        <li className="footer__item" key={"sub_" + subitem.name}>
                          <a className="text-decoration-none" href={subitem.href}>
                            <div className="footer__item-inner ">
                              <img className="footer__img imd-fluid" src={subitem.image} alt="" /> {subitem.name}
                            </div>
                          </a>
                        </li>
                      )}
                    </ul>
                  </div>
                </div>
              )}

              <div className="col-xl-1 col-lg-3 col-md-4 col-sm-6">
                <div className="footer__tools-wrapper ">
                  <h4 className="footer__heading mt-200">
                    UsePDF
                  </h4>
                  <ul className="d-flex flex-column gap-100 p-0">
                    <li className="footer__item">
                      <a href="/support/faq" className="text-decoration-none">
                        <div className="footer__item-inner">
                          Help
                        </div>
                      </a>
                    </li>
                    <li className="footer__item">
                      <a href="#" className="text-decoration-none">
                        <div className="footer__item-inner">
                          Sign In
                        </div>
                      </a>
                    </li>
                    <li className="footer__item">
                      <a href="#Blogs" className="text-decoration-none">
                        <div className="footer__item-inner">
                          Blog
                        </div>
                      </a>
                    </li>
                    <li className="footer__item">
                      <a href="/support/contact" className="text-decoration-none">
                        <div className="footer__item-inner">
                          Contact Us
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

            </div>

            <div className="mt-300 mt-lg-900">
              <div className="row items-center">
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-7 col-12">
                  <p className="footer__about-decs">© UsePDF All rights reserved 2024 |
                    <a className="text-neutral-400 text-decoration-none mx-2" href="/support/terms-and-conditions">Terms & Conditions</a>
                    <a className="text-neutral-400 text-decoration-none mx-2" href="/support/privacy-policy">Privacy policy</a>
                    <a className="text-neutral-400 text-decoration-none mx-2" href="/support/refund-cancel">Refund Policy</a>
                    <a className="text-neutral-400 text-decoration-none mx-2" href="/pricing">Pricing</a>
                    <a className="text-neutral-400 text-decoration-none mx-2" href="/support/faq">Help</a>
                  </p>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-5 col-12">
                  <img className="img-fluid block 2xl:w-[40%] xl:w-[40%] md:w-[50%] sm:w-[60%] w-[60%] 2xl:ml-auto xl:ml-auto lg:ml-auto sm:ml-auto md:ml-auto md:mr-0 mr-[-20px] md:mt-0 mt-2" src="/img/footer-all-payment-ic.svg" alt="Payment Icons" />
                </div>
                {/* <div className="col-md-6">
                  <div className="d-md-flex flex-column align-items-end mt-md-0 mt-200">
                    <div>
                      <ul className="d-flex gap-1 mb-0 p-0">

                        <li className="footer__start"><img className="img-fluid footer__start-img" src="/img/start.svg" alt="" />
                        </li>
                        <li className="footer__start"><img className="img-fluid footer__start-img" src="/img/start.svg" alt="" />
                        </li>
                        <li className="footer__start"><img className="img-fluid footer__start-img" src="/img/start.svg" alt="" />
                        </li>
                        <li className="footer__start"><img className="img-fluid footer__start-img" src="/img/start.svg" alt="" />
                        </li>
                        <li className="footer__start customer__start-drak"><img className="img-fluid footer__start-img"
                          src="/img/start.svg" alt="" /></li>
                      </ul>
                      <div className="d-flex align-item-center me-2">
                        <span className="customer__review">TrustScore <span className="fw-bold">3.9 / 33,264 </span>reviews</span>
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
